<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" :viewBox="`0 0 ${width} ${height}`">
    <g fill="none" fill-rule="evenodd">
      <g :fill="color" :stroke="color">
        <rect :width="barWidth" :height="height - 1" x=".5" y=".5" rx="2" />
        <rect :width="barWidth" :height="height - 1" :x=".5 + barWidth + gapWidth" y=".5" rx="2" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
  computed: {
    width() {
      return this.size * 0.85;
    },
    height() {
      return this.size;
    },
    /** Width of one of the two pause bars. */
    barWidth() {
      // Start the calculation by removing the space of .5 on the left and right
      let barWidth = this.width - 1;
      // Split the resulting width into two equal parts for the left and right pause bar
      barWidth /= 2;
      // These two halves must now be split into four equal parts
      barWidth /= 4;
      // Three of these quarters result in one bar width - the last quarter of both halves results in the gap in between
      return barWidth * 3;
    },
    /** Width of the gap in between the two pause bars. */
    gapWidth() {
      // Width of the gap is the total width minus the two bars and the two small spaces on the left and right
      return this.width - (2 * this.barWidth + 1);
    },
  },
};
</script>
